import { createAsyncThunk } from "@reduxjs/toolkit";
import { getFeedback, updateFeedbackStatus } from "store/services/feedback";
import { openToast } from "store/slices/common/toast.slice";
import { getApiMessage } from "utils/apiErrorCode";

export const GetFeedbackAction = createAsyncThunk(
  "feedback/get",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getFeedback(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const UpdateFeedbackStatus = createAsyncThunk(
  "feedback/update",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { filter, onSuccess, onError, ...rest } = payload;
    try {
      const res = await updateFeedbackStatus(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        if (onSuccess) {
          onSuccess();
        }
        dispatch(GetFeedbackAction(filter));
        return fulfillWithValue(res);
      }
      if (onError) {
        onError();
      }
      dispatch(
        openToast({
          type: "error",
          message: getApiMessage(res?.statusCode),
        }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);
